exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drivers {\n.el-table td {\r\n        border-bottom: 3px solid #60626650;\n}\n.el-table td, .el-table th.is-leaf {\r\n        border-bottom: 3px solid #60626650;\n}\n.el-table th > .cell {\r\n        -webkit-box-sizing: border-box;\r\n        box-sizing: border-box;\r\n        line-height: normal;\n}\n}", ""]);

// exports
